"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPackageStupidSimpleTransferLabel = void 0;
const getPackageStupidSimpleTransferLabel = (pkg) => {
    if (pkg.airport_transfer && pkg.course_transfer) {
        return "all transfers";
    }
    else {
        if (pkg.airport_transfer) {
            return "airport transfers";
        }
        else if (pkg.course_transfer) {
            return "golf transfers";
        }
    }
};
exports.getPackageStupidSimpleTransferLabel = getPackageStupidSimpleTransferLabel;
